import {
  TERMINAL_ATTACHMENT_REJECTED_CODE,
  TERMINAL_FOLDER_PICK_ERROR_CODES,
} from '../../../utils/constants/terminalConstants';

export enum TerminalDaemonErrorKind {
  FOLDER_PICK = 'folder_pick',
  ATTACHMENT = 'attachment',
  GENERIC = 'generic',
}

export function classifyDaemonError(code: string): TerminalDaemonErrorKind {
  if (TERMINAL_FOLDER_PICK_ERROR_CODES.includes(code)) {
    return TerminalDaemonErrorKind.FOLDER_PICK;
  }
  return code === TERMINAL_ATTACHMENT_REJECTED_CODE
    ? TerminalDaemonErrorKind.ATTACHMENT
    : TerminalDaemonErrorKind.GENERIC;
}
